import React from 'react';
import {checkLockStatus} from "../compare/compare.method";
import {Change} from "../compare/Change";


const PrimaryVehicleToolbar = ({vehicleData, setVehicleData, openModal,getCompareImages,t,
                                   handleModalClose, secondaryYear, vehiclesMakes, vehicleModel, trimModel,
                                   setTrimModel, setVehicleModel, setVehicleMake, vehiclesTrim, vehicleIndex, vehicleTypeName,
                                   driveType, setDriveType, isLocked, changeHandler}) => {
    return (
        <React.Fragment>
            <button
                id={0}
                className={"btn-default btn-change-compare"}
                value={getCompareImages[1]}
                onClick={(event) => changeHandler(0, getCompareImages[0])}
                disabled={checkLockStatus(getCompareImages[0], isLocked)}
            >
                {t('overview.changeSelectModal.change')}
            </button>
            <Change
                vehicleData={vehicleData}
                setVehicleData={setVehicleData}
                openModal={openModal}
                handleModalClose={handleModalClose}
                years={secondaryYear}
                vehicleMake={vehiclesMakes}
                vehicleModels={vehicleModel}
                trimModel={trimModel}
                setTrimModel={setTrimModel}
                setVehicleModel={setVehicleModel}
                setVehicleMake={setVehicleMake}
                vehiclesTrim={vehiclesTrim}
                vehicleIndex={vehicleIndex}
                vehicleTypeName={vehicleTypeName}
                driveType={driveType}
                setDriveType={setDriveType}
                lockedVehicle={isLocked}
            />
        </React.Fragment>
    );
}


export default PrimaryVehicleToolbar;